import styled from 'react-emotion';
import {colors} from '../../styles';

export const ModalWrapper = styled.div`
  position: absolute;
  width: 90%;
  max-width: 750px;
  top: 100px;
  right: 0;
  bottom: 0;
  left: auto;
  background: #fff;
  box-shadow: -11px -3px 19px 0px rgba(0, 0, 0, 0.1);
  border-left: solid 1px rgba(0, 0, 0, 0.2);
  z-index: 1000;

  @media (max-width: 850px) {
    max-width: 100%;
    width: 100%;

    .page-header > div {
      flex-wrap: initial;
      flex-direction: initial;
    }
  }

  .page-header {
    padding: 16px;
    background: ${colors.greenPrimary};
    margin-bottom: 0;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    color: #fff !important;

    .button.icon {
      color: #fff;
      padding: 0 !important;
      font-size: 24px;
      background-color: transparent;
    }
  }

  dl {
    color: #8e8776;

    > dt {
      font-weight: bold;
      text-transform: uppercase;

      a {
        color: ${colors.textLabel};
        i {
          color: ${colors.yellowLight};
        }
      }
    }

    > dd {
      margin: 0 0 10px 0;
      font-size: 12px;
    }
  }
`;
